interface StringConversionOptions {
  capitalizeFirstLetter?: boolean;
  capitalizeEachWord?: boolean;
}

/**
 * Converts a hyphenated string to a space-separated string with optional capitalization.
 *
 * @param input - The string to be converted.
 * @param options - An optional object to specify capitalization options.
 * @param options.capitalizeEachWord - If true, capitalizes the first letter of each word.
 * @param options.capitalizeFirstLetter - If true, capitalizes only the first letter of the resulting string.
 * @returns The converted string with spaces and optional capitalization.
 *
 * @example
 * ```typescript
 * convertHyphenated('hello-world'); // "hello world"
 * convertHyphenated('hello-world', { capitalizeEachWord: true }); // "Hello World"
 * convertHyphenated('hello-world', { capitalizeFirstLetter: true }); // "Hello world"
 * ```
 */
export function convertHyphenated(input: string, options: StringConversionOptions = {}): string {
  let result = input.replace(/-/g, ' ');

  if (options.capitalizeEachWord) {
    result = result.replace(/\b\w/g, (char) => char.toUpperCase());
  } else if (options.capitalizeFirstLetter) {
    result = result.charAt(0).toUpperCase() + result.slice(1);
  }

  return result;
}
